import { type ReactNode } from "react"
import { useAuthToken } from "@hooks/useAuthToken"
import { useAuditInterceptor } from "@hooks/useAuditInterceptor"
import { useUnauthorizedInterceptor } from "@hooks/useUnauthorizedInterceptor"
import { useSuccessfulErrorInterceptor } from "@hooks/useSuccessfulErrorInterceptor"
import { MainLoader } from "@components/MainLoader"

const AxiosInterceptorWrapper = ({ children }: { children: ReactNode }) => {
  const { isTokenConfigured, isAuthenticated, tokenError } = useAuthToken()
  useAuditInterceptor() // This could be moved after auth succeded in Callback component
  useUnauthorizedInterceptor()
  useSuccessfulErrorInterceptor()

  // If there's an error getting the token (e.g., user is inactive), show the error message
  if (isAuthenticated && tokenError) {
    const errorMessage =
      typeof tokenError === "string"
        ? tokenError
        : "An error occurred while authenticating. Please contact support."

    return (
      <div className="tw:flex tw:h-screen tw:items-center tw:justify-center">
        <div className="tw:max-w-md tw:rounded-lg tw:bg-red-50 tw:p-6 tw:shadow-md">
          <h2 className="tw:mb-2 tw:text-lg tw:font-semibold tw:text-red-800">
            Authentication Error
          </h2>
          <p className="tw:text-red-700">{errorMessage}</p>
        </div>
      </div>
    )
  }

  // If the token is not configured yet, show a loading spinner to prevent rendering children that might call APIs without the axios token
  if (isAuthenticated && !isTokenConfigured) {
    return <MainLoader />
  }

  return <>{children}</>
}

export { AxiosInterceptorWrapper }
